import { AdminStoresRegisterTemplate } from "../../Templates/AdminStoresRegisterTemplate";

export const AdminStoresRegister = () => {
  return <AdminStoresRegisterTemplate />;
};
